const facts = [
  {
    icon: "ri-shield-star-line",
    title: "入口永久有效",
    desc: "无论外界如何变化，总有通道为你保留，随时进得来。",
    tint: "bg-primary-100 text-primary-600",
  },
  {
    icon: "ri-save-3-line",
    title: "收藏即不失联",
    desc: "把本站收藏好，换址后仍能从同一入口重新找到组织。",
    tint: "bg-accent-100 text-accent-600",
  },
  {
    icon: "ri-radio-button-line",
    title: "换址第一时间同步",
    desc: "任何新地址变化，都会在首页顶部与公告区实时置顶更新。",
    tint: "bg-secondary-100 text-secondary-700",
  },
  {
    icon: "ri-user-star-line",
    title: "老用户免注册直入",
    desc: "无需登录即可直接浏览讨论，老朋友回来零门槛。",
    tint: "bg-primary-100 text-primary-600",
  },
];

export default function TrustStrip() {
  return (
    <section className="border-y border-background-200/70 bg-background-100/60">
      <div className="mx-auto grid max-w-7xl gap-px px-4 py-12 md:grid-cols-2 md:px-6 lg:grid-cols-4 lg:py-16">
        {facts.map((f) => (
          <div key={f.title} className="px-2 py-5 md:py-2">
            <span className={`flex h-11 w-11 items-center justify-center rounded-full text-lg ${f.tint}`}>
              <i className={f.icon}></i>
            </span>
            <h3 className="mt-4 text-base font-semibold text-foreground-950">{f.title}</h3>
            <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{f.desc}</p>
          </div>
        ))}
      </div>
    </section>
  );
}